function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function (_typeof2) { function _typeof(_x) { return _typeof2.apply(this, arguments); } _typeof.toString = function () { return _typeof2.toString(); }; return _typeof; }(function (obj) { return typeof obj; }); } else { _typeof = function (_typeof3) { function _typeof(_x2) { return _typeof3.apply(this, arguments); } _typeof.toString = function () { return _typeof3.toString(); }; return _typeof; }(function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }); } return _typeof(obj); }

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if ((typeof Reflect === "undefined" ? "undefined" : _typeof(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

import { messages, pagerOf, pagerPage } from './../messages';
import { VueComponent } from '@progress/kendo-vue-common';
import Component from 'vue-class-component';
import { provideLocalizationService } from '@progress/kendo-vue-intl';
/**
 * @hidden
 */

var PagerInput =
/** @class */
function (_super) {
  __extends(PagerInput, _super);

  function PagerInput() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this._text = undefined;
    return _this;
  }

  PagerInput.prototype.changeHangler = function (e) {
    var text = this._text = e.target.value.replace(/\D/g, ''); // @ts-ignore

    this.$forceUpdate();

    if (text) {
      this.$props.pageChange(parseInt(text, 10), e);
    }
  };

  PagerInput.prototype.blurHandler = function () {
    // @ts-ignore
    this.$forceUpdate();
  };

  PagerInput.prototype.value = function () {
    var value = this._text === undefined ? this.$props.currentPage.toString() : this._text;
    this._text = undefined;
    return value;
  }; // @ts-ignore


  PagerInput.prototype.render = function (h) {
    var localizationService = provideLocalizationService(this);
    return h("span", {
      "class": "k-pager-input k-label"
    }, [localizationService.toLanguageString(pagerPage, messages[pagerPage]), " ", h("input", {
      "class": "k-textbox",
      domProps: {
        "value": this.value()
      },
      on: {
        "blur": this.blurHandler,
        "change": this.changeHangler
      }
    }), " ", localizationService.toLanguageString(pagerOf, messages[pagerOf]), " ", this.$props.totalPages]);
  };

  PagerInput = __decorate([Component({
    props: {
      totalPages: Number,
      currentPage: Number,
      pageChange: Function
    },
    inject: {
      kendoLocalizationService: {
        default: null
      }
    }
  })], PagerInput);
  return PagerInput;
}(VueComponent);

export { PagerInput }; // registerForLocalization(PagerInput);